function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Relationships } from '@leverege/molten/data-source';
import { ItemInfoScreen } from '@leverege/molten/screens';
import FirmwareApplicationItemDelegate from "../../delegates/firmwareApplication/FirmwareApplicationItemDelegate.js";
import { Types, Routes } from "../../constants/index.js";
export default {
  id: 'leverege.fotaApi.route.firmwareApplication.item.info',
  matches: {
    client: 'ItemScreen',
    objectType: Types.firmwareApplication,
    path: 'leverege.fotaApi.firmwareApplication'
  },
  exact: true,
  path: Routes.rootFirmwareApplicationItemInfo,
  render: props => {
    const relationship = Relationships.getByPath('leverege.fotaApi.firmwareApplication');
    const resourceId = props?.match?.params?.firmwareApplicationId;
    return /*#__PURE__*/React.createElement(ItemInfoScreen, _extends({}, props, {
      relationship: relationship,
      resourceId: resourceId,
      objectType: Types.firmwareApplication,
      delegate: new FirmwareApplicationItemDelegate({
        relationship,
        match: props?.match,
        id: resourceId
      })
    }));
  }
};